module.exports = __webpack_public_path__ + "static/media/card-blog3.40c2561b.jpg";